<template>
    <l-map ref="myMap" :options="{ zoomControl: false, competitionId: competition.id }"
        @ready="(map = $event), readGpxFiles(), $emit('ready', $event)" :zoom="zoom" class="map">
        <l-tile-layer :url="url" />
        <l-control-zoom position="bottomright" />
        <l-control position="bottomleft">
            <div class="d-flex">
                <div class="mode" @click="switchMode()">
                    <div class="mode__switch">
                        <div class="mode__switch-btn" :class="{
                            'mode__switch-btn--active': isLiveMode,
                        }"></div>
                    </div>
                    <div class="mode__text">
                        <span :class="{ 'mode__text--red mar10': isLiveMode }">LIVE</span>
                        <template v-if="isLiveMode">{{
                            isPastCurrentClassification()
                                ? getDurationPastCompetition()
                                : liveTime
                        }}</template>
                    </div>
                </div>
                <!-- <base-button-1 class="results__button--results" @click="showResults()">
                    <span>WYNIKI</span><i class="fas fa-flag-checkered"></i>
                </base-button-1> -->
            </div>
        </l-control>
        <l-circle v-if="!this.gpxFiles[this.selectedClassificationId].url" :lat-lng="circleCenter"
            :radius="circle.radius" :color="circle.color" :fill="false" dashArray="2, 5" />
        <slot />
    </l-map>
</template>

<script>
import L from 'leaflet'
import { LMap, LTileLayer, LControlZoom, LControl, LCircle } from 'vue2-leaflet'
import { Icon } from 'leaflet'
import 'leaflet-gpx'
import { mapGetters, mapMutations } from 'vuex'
import {
    SET_SELECTED_CLASSIFICATION_ID,
    SET_TRACK_BOUNDS,
    SET_MODE,
    SET_SHOW_DISTANCE,
} from '@/store/mutations.type'
import { eventBus } from '@/main'
import moment from 'moment'
import {
    setDistanceMarkers,
    removeDistanceMarkers,
    setBoundsFromLatLng,
} from '@/utils/distanceMarkers'
// import BaseButton1 from '@/components/BaseButton1'
export default {
    components: {
        LMap,
        LTileLayer,
        LControlZoom,
        LControl,
        // BaseButton1,
        LCircle,
    },
    props: {
        classifications: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 13,
            tracks: {},
            highlightedTrackColor: '#37474f',
            disabledTrackColor: '#78909c',
            map: null,
            liveTime: '00:00:00',
            circle: {
                center: this.circleCenter,
                radius: 1000 * 10, // promien w m =>  set to: 10 km
                color: '#78909c'
            },
            rectangle: null,
        }
    },
    computed: {
        ...mapGetters([
            'gpxFiles',
            'selectedClassificationId',
            'isLiveMode',
            'competitions',
            'devices',
            'isShowDistanceMarkers',
            'amountDistanceMarkers',
            'isRevertDistanceMarkers',
            'isRevertDistanceMarkers',
            'selectedClassificationEventTimes',
            'eventTimesData',
        ]),
        circleCenter() {
            return [this.competition.locationLat, this.competition.locationLng]
        },
        classificationsIds() {
            const classificationsIds = []
            for (const classification of this.classifications) {
                classificationsIds.push(classification.id)
            }
            return classificationsIds
        },
        competition() {
            return this.competitions[this.classifications[0].competition]
        },
        currentClassification() {
            return this.classifications.find(
                (cls) => cls.id === this.selectedClassificationId
            )
        },
    },
    created() {
        this.deleteDefaultIcons()
        eventBus.$on('selectedClassification', () => {
            for (const trackId in this.tracks) {
                if (
                    this.tracks[trackId].classification ===
                    this.selectedClassificationId
                ) {
                    this.centerOnTrack(this.tracks[trackId])
                }
            }
        })
    },
    methods: {
        ...mapMutations([
            SET_SELECTED_CLASSIFICATION_ID,
            SET_TRACK_BOUNDS,
            SET_MODE,
            SET_SHOW_DISTANCE,
        ]),
        isPastCurrentClassification() {
            if (this.currentClassification.endTime || (this.eventTimesData && this.eventTimesData.end_event) || (this.selectedClassificationEventTimes && this.selectedClassificationEventTimes.end_event)) {
                return true
            } else {
                return false
            }
        },
        getDurationPastCompetition() {
            const endTime = (this.selectedClassificationEventTimes && this.selectedClassificationEventTimes.end_event) ? moment(this.selectedClassificationEventTimes.end_event) : (this.currentClassification.endTime || moment(this.eventTimesData.end_event))
            const startTime =
                (this.selectedClassificationEventTimes && this.selectedClassificationEventTimes.start_event) ?
                    this.selectedClassificationEventTimes.start_event :
                    (this.currentClassification.startTime ??
                        this.competition.startedTime)
            let diff = endTime.diff(startTime)
            let duration = moment.duration(diff)
            let days = duration.get('d')
            let time = (time = moment
                .utc(duration.asMilliseconds())
                .format('HH:mm:ss'))
            if (days > 0) {
                // [hh, mm, ss]
                let timeElements = time.split(':')
                timeElements[0] = Number.parseInt(timeElements[0]) + days * 24
                time = timeElements.join(':')
            }
            return time
        },
        getLiveTime() {
            if (this.isLiveMode) {
                let diff, startTime, currentTime, duration, time

                startTime = (this.selectedClassificationEventTimes && this.selectedClassificationEventTimes.start_event) ?
                    this.selectedClassificationEventTimes.start_event
                    : (this.currentClassification.startTime
                        ? this.currentClassification.startTime
                        : this.competition.startedTime)

                currentTime = moment()
                diff = currentTime.diff(startTime)
                if (diff < 0) {
                    return (this.liveTime = '00:00:00')
                }
                duration = moment.duration(diff)
                let d = duration.get('d')
                time = moment.utc(duration.asMilliseconds()).format('HH:mm:ss')
                if (d > 0) {
                    // [hh, mm, ss]
                    let timeElements = time.split(':')
                    timeElements[0] = Number.parseInt(timeElements[0]) + d * 24
                    time = timeElements.join(':')
                    return (this.liveTime = time)
                }
                return (this.liveTime = time)
            }
            return 0
        },
        deleteDefaultIcons() {
            delete Icon.Default.prototype._getIconUrl
        },

        readGpxFiles() {
            this.tracks = {}
            for (const id of this.classificationsIds) {
                if (!this.gpxFiles[id].url) {
                    let trackbound = setBoundsFromLatLng({ lat: this.competition.locationLat, lng: this.competition.locationLng }, 20)
                    trackbound.id = id
                    this.SET_TRACK_BOUNDS(trackbound)
                } else {
                    this.tracks[id] = new L.GPX(this.gpxFiles[id].url, {
                        async: true,
                        gpx_options: {
                            parseElements: ['track', 'route'],
                        },
                        polyline_options: {
                            color: this.disabledTrackColor,
                            opacity: 1,
                            weight: 5,
                            lineCap: 'round',
                        },
                        marker_options: {
                            startIconUrl: null,
                            endIconUrl: null,
                            shadowUrl: null,
                        },
                    })
                        .on('loaded', (e) => {
                            // TrackBound's index is classification id.
                            let trackbound = e.target.getBounds().pad(0.3)
                            trackbound.id = id
                            e.target.classification = id
                            this.SET_TRACK_BOUNDS(trackbound)
                            this.rectangle = trackbound
                            e.target.bringToBack()
                            if (this.selectedClassificationId === id) {
                                this.centerOnTrack(e.target)
                                this.setDisabledTracks()
                                this.highlightTrack(e.target)
                            }
                            // if (
                            //     this.classificationsIds[
                            //     this.classificationsIds.length - 1
                            //     ] === id
                            // ) {
                            //     this.$emit('gpx:ready')
                            // }
                        })
                        .on('click', (e) => this.trackClickHandler(e.target))
                        .on('mouseover', (e) => {
                            this.setDisabledTracks()
                            this.highlightTrack(e.target)
                        })
                        .on('mouseout', () => {
                            const selectedTrack = this.findSelectedTrack()
                            this.setDisabledTracks()
                            this.highlightTrack(selectedTrack)
                        })
                        .addTo(this.map)
                }
                if (
                    this.classificationsIds[
                    this.classificationsIds.length - 1
                    ] === id
                ) {
                    this.$emit('gpx:ready')
                }
            }
            if (this.tracks) {
                this.centerOnTrack(this.competition)
            }

            // this.$emit('gpx:ready')
        },
        trackClickHandler(track) {
            // Change selected classification.
            const [clickedClassification] = this.classifications.filter(
                (classification) => classification.id === track.classification
            )
            this.SET_SELECTED_CLASSIFICATION_ID(clickedClassification.id)
        },
        centerOnTrack(track) {
            if (track.getBounds) {
                this.map.fitBounds(track.getBounds())
            } else {
                this.map.panTo([this.competition.locationLat, this.competition.locationLng])
            }
        },
        setDisabledTracks() {
            for (const trackId in this.tracks) {
                if (
                    Object.prototype.hasOwnProperty.call(this.tracks, trackId)
                ) {
                    this.tracks[trackId].bringToBack()
                    this.tracks[trackId].setStyle({
                        color: this.disabledTrackColor,
                    })
                }
            }
        },
        highlightTrack(track) {
            if (track !== undefined) {
                track.bringToFront()
                track.setStyle({ color: this.highlightedTrackColor })
            }
        },
        clearGpxLayers() {
            this.map.eachLayer((layer) => {
                // eslint-disable-next-line no-underscore-dangle
                if (layer._gpx) {
                    this.map.removeLayer(layer)
                }
            })
        },
        findSelectedTrack() {
            for (const trackId in this.tracks) {
                if (
                    Number.parseInt(trackId, 10) ===
                    this.selectedClassificationId
                ) {
                    return this.tracks[trackId]
                }
            }
            return undefined
        },
        switchMode() {
            this.SET_MODE(!this.isLiveMode)
        },
        showResults() {
            this.$emit('showResults', true)
        },
        showDistanceMarkers() {
            if (this.map && this.tracks && this.tracks[this.selectedClassificationId] && this.tracks[this.selectedClassificationId]._gpx) {
                removeDistanceMarkers(this.map)
                let currentLayer
                this.map.eachLayer((layer) => {
                    if (layer.classification === this.selectedClassificationId) {
                        currentLayer = layer
                    }
                })
                const latLngs = currentLayer.getLayers()[0].getLatLngs()
                const maxDistance = currentLayer.get_distance()
                const offset = Math.floor(maxDistance / this.amountDistanceMarkers)
                setDistanceMarkers(
                    latLngs,
                    this.map,
                    offset,
                    maxDistance,
                    this.isRevertDistanceMarkers
                )
            } else {
                setTimeout(() => this.showDistanceMarkers(), 1000)
            }
        },
    },

    watch: {
        selectedClassificationId() {
            if (this.isShowDistanceMarkers) { this.showDistanceMarkers() }
            this.setDisabledTracks()
            this.isPastCurrentClassification()
            for (const trackId in this.tracks) {
                if (
                    this.tracks[trackId].classification ===
                    this.selectedClassificationId
                ) {
                    this.highlightTrack(this.tracks[trackId])
                    this.centerOnTrack(this.tracks[trackId])
                }
            }
        },
        isLiveMode: {
            immediate: true,
            handler() {
                if (this.isLiveMode && !this.isPastCurrentClassification()) {
                    window.timeInterval = setInterval(this.getLiveTime, 500)
                } else {
                    clearInterval(window.timeInterval)
                }
            },
        },
        isShowDistanceMarkers: {
            immediate: true,
            handler() {
                if (!this.isShowDistanceMarkers && this.tracks[this.selectedClassificationId]._gpx) {
                    removeDistanceMarkers(this.map)
                } else {
                    this.showDistanceMarkers()
                }
            }
        },
        amountDistanceMarkers() {
            this.showDistanceMarkers()
        },
        isRevertDistanceMarkers() {
            this.showDistanceMarkers()
        },
    },
}
</script>
<style lang="scss" scoped>
.map {
    border-radius: 4px;
}

.mode {
    border-radius: 5px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1), 0 0 2px 0 rgba(55, 71, 79, 0.2);
    background-color: $white;
    display: flex;
    padding: 10px 16px;
    line-height: 1.43;

    &__switch {
        height: 100%;

        &-btn {
            width: 40px;
            height: 24px;
            background-color: $pale-grey;
            border-radius: 12px;
            position: relative;
            cursor: pointer;
            transition: all 0.3s;

            &::after {
                transition: all 0.3s;
                content: '';
                position: absolute;
                top: 2px;
                left: 2px;
                width: 20px;
                height: 20px;
                border-radius: 12px;
                display: inline-block;
                background-color: $white;
                box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1),
                    0 0 2px 0 rgba(55, 71, 79, 0.2);
            }

            &--active {
                background-color: $red-orange;
                opacity: 1;

                &::after {
                    left: 18px;
                }
            }
        }
    }

    &__text {
        margin-left: 10px;
        font-size: 18px;
        transition: all 0.4s;

        &--red {
            color: $pinky-red;
        }
    }
}

@keyframes lds-roller {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.results__button {
    &--close {
        margin: 3px 10px;
        display: flex;
        gap: 8px;
        min-width: 100px;
        max-width: 200px;
        background-color: #546e7a;
        color: #fff;
        font-weight: 700;
        box-shadow: 0 8px 12px 0 rgba(0, 0, 0, .2);

        &:hover {
            background-color: darken($color: #546e7a, $amount: 4%);
        }
    }

    &--results {
        margin-left: 10px;
        padding: 10px 16px;
        display: flex;
        gap: 8px;
        height: unset;
        min-width: 100px;
        max-width: 200px;
        background-color: #546e7a;
        color: #fff;
        font-size: 18px;
        box-shadow: 0 8px 12px 0 rgba(0, 0, 0, .2);

        &:hover {
            background-color: darken($color: #546e7a, $amount: 4%);
        }
    }
}
</style>
